import { ConstantsTableColsEmissionsquelle } from "./constants-table-cols-emissionsquelle";

export class ConstantsTableColsSonstige extends ConstantsTableColsEmissionsquelle {


  public static getColumns(): string[] {
    return [
      this.EDIT_REMOVE,      
      this.BEZEICHNUNG,
      this.GEWICHTUNGSFAKTOR,
      this.EMISSION_GE,
      this.X_KOORDINATE,
      this.Y_KOORDINATE,
      this.EMPTY      
    ];
  }
}
